export const ERROR_NOT_ALLOWED = 'not-allowed';
export const ERROR_NO_SPEECH = 'no-speech';
